"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardSubHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("../../interfaces");
var EventEmitter_1 = __importDefault(require("../../utilities/EventEmitter"));
var LeaderboardSubHeader = function (_a) {
    var renderButton = _a.renderButton, playerPosition = _a.playerPosition, totalPlayers = _a.totalPlayers, code = _a.code;
    var handleButtonClick = function () {
        EventEmitter_1.default.emit(interfaces_1.Events.SCROLL_TO_YOU, code);
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-subheader" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "leaderboard-subheader--position" }, { children: ["Your position: ", playerPosition, "/", totalPlayers] })), renderButton ? renderButton(handleButtonClick) :
                    (0, jsx_runtime_1.jsx)("button", __assign({ disabled: playerPosition === "-", type: "button", onClick: handleButtonClick, className: "leaderboard-subheader--button" }, { children: "View" }))] }) })));
};
exports.LeaderboardSubHeader = LeaderboardSubHeader;
